<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
      </div>
      <grid-filters grid-data="isolatedGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="isolatedGrid" name="isolatedGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'isolatedSubmittedGrid',
  components: {
    Grid
  },
  data() {
    return {
      itemToDelete: null,
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field: 'dsr_id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        },
        status_id: {
          type: 'number'
        }
      },
      preload: [],
      url: 'isolated/submitted',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'ID',
        width: '90px'
      },
      {
        field: 'year',
        title: 'Ano',
        width: '90px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '90px'
      },
      {
        field: 'dsr_name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'dsr_username',
        title: 'Username',
        width: '180px'
      },
      {
        field: 'receipt_number',
        title: 'Recibo',
        width: '180px'
      },
      {
        field: 'image',
        title: 'Imagem',
        width: '120px',
        template: '<a target="_blank" href="#= image #">Ver</a>'
      },
      {
        field: 'status_description',
        title: 'Estado',
        width: '120px'
      },
      {
        field: 'message',
        title: 'Mensagem',
        width: '300px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        width: '180px'
      },
      {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        width: '180px'
      }]
    }
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: 'submitted.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('submitted.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      }
      return ''
    }
  }
}
</script>
